import golfToEid from 'golf-to-eid';
import assign from 'object-assign';

export default function eid(opts = { }) {
  opts = assign({ }, opts, {
    prefix: 'uxp.hyd.utility_bar',
    postfix: 'link.click'
  });

  let key = opts.key;
  if (opts.manifest) {
    key = key.replace(/shared/i, opts.manifest);
  }

  return golfToEid(key, opts);
}
